import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import * as Models from 'appshared/shared-models';

@Component({
	selector: '[app-column-headings]',
	templateUrl: './column-headings.component.html',
	styleUrls: [],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnHeadingsComponent {
	@Input() parentApi !: any;
	@Input() columnDefs: Models.ColumnDefinition[] = [];
	@Input() fieldsToShow: any[] = [];
	@Input() displayOptions: Models.TableDisplayOptions = new Models.TableDisplayOptions();
	@Input() extraClasses: string = '';
	@Input() pre: number = 0;
	@Input() post: number = 0;

	// ------------------------------------------------------------------------
	constructor() {
	}

	// ------------------------------------------------------------------------
	setSortBy(field: string) {
		if (this.parentApi) this.parentApi.setSortBy(field);
	} // setSortBy
}
